export { default as AppStoreLinks } from "./AppStoreLinks";
export type { AppStoreLinksProps } from "./AppStoreLinks.types";
